import { render, staticRenderFns } from "./SettingsButtonV2.vue?vue&type=template&id=d88f11ca&scoped=true&"
import script from "./SettingsButtonV2.vue?vue&type=script&lang=js&"
export * from "./SettingsButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./SettingsButtonV2.vue?vue&type=style&index=0&id=d88f11ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88f11ca",
  null
  
)

export default component.exports